module.exports = __webpack_public_path__ + "img/icon-next.a7810b5d.svg";